import moment from 'moment'

export function getCurrentYear() {
  return moment().year()
}
